
export const comingSoonMixins = {
	methods: {
		// Help doesn't have a route yet.
		showHelpComingSoon() {
			this.$router.push('/contact-us');
		},
		// For components that have routes
		showComingSoonAlert() {
			const { show, component } = this.$store.getters.getComingSoon;
			const { tracking: { subscriptionStatus, trackingSerialNumber, isTrackingDeviceConnected } } = this.$store.getters.getSubscriptions;
			const hasSerialNumberAndActive = (subscriptionStatus === 'A' && (!trackingSerialNumber || !isTrackingDeviceConnected));

			let imageUrl = `${require('@/assets/images/_shared/coming-soon.png')}`;
			let imageAlt = 'Coming Soon Dog';
			let title = 'Coming Soon!';
			let text = `${component} feature is under development.`;

			if (component === 'Tracking') {
				imageUrl = `${require('@/assets/images/_shared/success-dog.png')}`;
				imageAlt = 'Get Tracking Dog';
				title = hasSerialNumberAndActive ? 'Almost there!' : 'Subscribe Now!'
				text = hasSerialNumberAndActive ? 'Waiting for the admin to add the tracking serial number or connect it to your pet' : 'Subscribe to monitor your pet\'s location';
			}

			if (show) {
				this.$swal({
					imageHeight: '30px',
					imageUrl,
					imageAlt,
					title,
					text,
					customClass: {
						header: 'header-notification',
						title: 'title-notification',
					},
					confirmButtonColor: '#4B8BFF',
					confirmButtonText: 'Got it'
				});

				this.$store.commit('clearComingSoon');
			}
		},
		showHomeComingSoonAlert() {
			this.$swal({
				imageHeight: '30px',
				imageUrl: `${require('@/assets/images/_shared/coming-soon.png')}`,
				imageAlt: 'Coming Soon Dog',
				title: 'Coming Soon!',
				text: `This feature is under development.`,
				confirmButtonColor: '#4B8BFF',
				confirmButtonText: 'Got it'
			});
		}
	}
}